/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Nav_DistributionInputs */

const en_landing_preview_nav_distribution = /** @type {(inputs: Landing_Preview_Nav_DistributionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribution`)
};

/**
* | output |
* | --- |
* | "Distribution" |
*
* @param {Landing_Preview_Nav_DistributionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_nav_distribution = /** @type {((inputs?: Landing_Preview_Nav_DistributionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Nav_DistributionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_nav_distribution(inputs)
});